// @ts-nocheck
import { useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';

import { ls } from '@/lib/utils';

export const useTrapp = () => {
  const tr = useTranslations();
  return tr;
};

export const useUrlParams = () => {
  const searchParams = useSearchParams();

  const getAllUrlParams = () => {
    const obj = {};
    for (const [key, value] of searchParams.entries()) {
      obj[key] = value;
    }
    return obj;
  };

  const setParams = (params) => {
    if (!ls) return null;
    ls.setItem('params', JSON.stringify(params));
  };

  const getParams = () => {
    if (!ls) return null;
    const params = ls.getItem('params');
    return JSON.parse(params);
  };

  const removeParamsUrl = () => {
    if (typeof window !== 'undefined') {
      history.replaceState(null, '', `${location.pathname}`);
    }
  };

  return { getAllUrlParams, setParams, getParams, removeParamsUrl };
};
